module.exports = __webpack_public_path__ + "static/media/airplane1.3c06bc66.jpg";